<div class="container-full" style="margin-top:30px;margin-left:30px;margin-right:30px;">
    
    <span class="ace-heading-text-primary" style="font-size:21px;">Home/Dashboard</span>
    <div class="row" style="margin-top:20px;">
        <div class="col-12">
            <!-- <mat-tab-group> -->
                <!-- <mat-tab label="Dashboard - All data is refreshed real time when displayed">
                    <div style="width:99%;">
                        <div class="row" style="margin-top:20px;">
                            <div class="col-12"> -->
                                <app-invoice-aging></app-invoice-aging>
                            <!-- </div>
                        </div>
                    </div>
                </mat-tab> -->
                <!-- <mat-tab label="spACE AR">
                    spACE AR
                
                </mat-tab>
                <mat-tab label="spACE Portal"> 
                    spACe Portal
                </mat-tab> -->
              <!-- </mat-tab-group> -->

        </div>

     
    </div>
</div>

<div style="margin-top:30px;margin-left:20px;margin-right:20px;">
</div>

    

